import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { changeLanguage, getCurrentLanguage, DEFAULT_LANGUAGE } from "@/i18n";
import type { SupportedLanguage } from "@/i18n";

interface LanguageState {
  current: SupportedLanguage;
}

const initialState: LanguageState = {
  current: getCurrentLanguage() || DEFAULT_LANGUAGE,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<SupportedLanguage>) => {
      state.current = action.payload;
      changeLanguage(action.payload);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
